<script>
    import {Doughnut, mixins} from 'vue-chartjs'

    export default {
        extends: Doughnut,
        mixins: [mixins.reactiveProp],
        props: ['chartData'],
        data() {
            return {
                options: {
                    responsive: true,
                    rotation: -1.0 * Math.PI,
                    circumference: Math.PI,
                }
            }
        },
        computed: {
            getOptions(variableOptions) {
                return {
                    cutoutPercentage: 75,
                    title: {
                        display: false,
                    },
                    elements: {
                        arc: {
                            borderWidth: 0
                        }
                    },
                    spanGaps: true,
                    animation: {
                        duration: 0,
                        easing: 'easeOutCubic',
                        onProgress: (e) => {
                            if (!self.animationComplete) {
                                let progress = e.currentStep / e.numSteps * 100;
                                // console.log(progress)
                                // self.$store.commit('setLoading', true)
                            }
                        },
                        onComplete: () => {

                            self.animationComplete = true

                            // self.$store.commit('setLoading', false)
                        }
                    },
                    scales: {
                        yAxes: [{
                            display: false,
                            autoSkip: true,
                            // stacked:true,
                            id: 'left',
                            position: 'left',
                            beginAtZero: true,
                            gridLines: {
                                display: false,
                                color: '#1e1e2f',
                                drawBorder: false,
                                zeroLineColor: '#1e1e2f',
                            },
                            ticks: {
                                beginAtZero: true,
                                min: 0,
                            },
                            scaleLabel: {
                                display: false,
                                fontSize: 20
                            },
                        }
                        ],
                        xAxes: [
                            {
                                beginAtZero: true,
                                autoSkip: true,
                                display: false,
                                gridLines: {
                                    display: false,
                                    color: '#1e1e2f',
                                    zeroLineColor: '#1e1e2f',
                                },
                                ticks: {
                                    beginAtZero: true,
                                    fontColor: '#ffffff',
                                }
                            }]
                    },
                    legend: {
                        display: false,
                    },
                    layout: {
                        padding: {
                            left: 0,
                            right: 0,
                            top: 10,
                            bottom: 10
                        }
                    },
                    responsive: true,
                    maintainAspectRatio: false,

                }
            }
        },
        mounted() {
            this.renderChart(this.chartData, this.getOptions)
        }
    }
</script>

<style>
</style>